/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useEffect } from "react";
import { Col, Container, Nav, Row, Tab } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import HeroSection from "./HeroSection";
import VideoSection from "./videoSection";
import { getData } from "./redux/action";

function VideoLiabrary() {
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getData());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Container className="homePageAdmin">
      <div className="d-flex flex-wrap align-items-center justify-content-between titleBoxWrap mb-25">
        <h2 className="adminSectionTitle">Video Tutorials</h2>
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => {
            history.push("/admin/pages");
          }}
        >
          <i className="fa-regular fa-arrow-left" /> Back
        </button>
      </div>
      <Tab.Container id="left-tabs-example" defaultActiveKey="link1">
        <Row>
          <Col md={3}>
            <Nav variant="pills" className="flex-column nav-pills1">
              <Nav.Item>
                <Nav.Link eventKey="link1">Hero Section</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="link2">Video Section</Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>
          <Col md={9}>
            <Tab.Content className="themeTabs">
              <Tab.Pane eventKey="link1">
                <HeroSection />
              </Tab.Pane>
              <Tab.Pane eventKey="link2">
                <VideoSection />
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </Container>
  );
}

export default VideoLiabrary;
